import { useSearchParams } from "react-router-dom";
import BasicPage from "../../components/BasicPage/BasicPage";
import styles from "./NewsSearchResults.module.css";
import usePageTitle from "../../hooks/usePageTitle";
import ArrowSubtitle from "../../components/ArrowSubtitle/ArrowSubtitle";
import { useContext, useEffect, useState } from "react";
import { PostContext } from "../../components/PostProvider/PostProvider";
import CategoryChip from "../../components/CategoryChip/CategoryChip";
import PagedSection from "../../components/PagedSection/PagedSection";
import HorizontalPostLink from "../../components/HorizontalPostLink/HorizontalPostLink";
import NewsSearchBar from "../../components/NewsSearchBar/NewsSearchBar";
import SearchCover from "../../components/SearchCover/SearchCover";

function NewsSearchResults() {
    const { getPostsWithQuery } = useContext(PostContext);
    const [searchParams] = useSearchParams();
    const [searchBarState, setSearchBarState] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);

    const [totalQueryResults, setTotalQueryResults] = useState(0);
    const [searchResults, setSearchResults] = useState({});

    useEffect(() => {
        const load = async () => {
            const results = await getPostsWithQuery(
                currentPage,
                perPage,
                "",
                searchParams.get("q"),
                setLoading,
                setTotalQueryResults
            );
            setSearchResults(results);
        };
        load();
    }, [currentPage, getPostsWithQuery, perPage, searchParams]);

    usePageTitle("Search Results | News");

    return (
        <BasicPage>
            <SearchCover
                searchBarState={searchBarState}
                setSearchBarState={setSearchBarState}
            />
            <div id={styles.heading}>
                <ArrowSubtitle dark={true} text={"News"} />
                <h1 className="main-h1">
                    Search Results for
                    <br />
                    <span style={{ color: "var(--keel-orange)" }}>
                        {searchParams.get("q")}
                    </span>
                </h1>
            </div>

            <NewsSearchBar
                searchBarState={searchBarState}
                setSearchBarState={setSearchBarState}
                initialValue={searchParams.get("q")}
            />

            <div className={styles.list_container}>
                <h2>Categories</h2>
                <div
                    className={[
                        styles.categories_container,
                        "hide-scrollbar",
                    ].join(" ")}
                >
                    {loading ? (
                        <CategoryChip large={true} placeholder={true} />
                    ) : searchResults?.categories?.length > 0 ? (
                        searchResults?.categories?.map((cat) => (
                            <CategoryChip
                                large={true}
                                key={cat.slug}
                                {...cat}
                            />
                        ))
                    ) : (
                        <div>No results found</div>
                    )}
                </div>
            </div>
            <div className={styles.list_container}>
                <h2>Posts</h2>
                <PagedSection
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    total={totalQueryResults}
                    className={[styles.posts_container, "section-content"].join(
                        " "
                    )}
                >
                    {loading ? (
                        Array(perPage)
                            .fill(0)
                            .map((_, index) => (
                                <HorizontalPostLink
                                    key={index}
                                    placeholder={true}
                                />
                            ))
                    ) : searchResults?.posts?.length > 0 ? (
                        searchResults?.posts?.map((post) => {
                            return (
                                <HorizontalPostLink key={post.id} post={post} />
                            );
                        })
                    ) : (
                        <div>No results found</div>
                    )}
                </PagedSection>
            </div>
        </BasicPage>
    );
}

export default NewsSearchResults;
